<template>

      <!-- [ Invite User form default ] start -->
      <el-row v-if="showForm" :gutter="20" type="flex" justify="center">
        <el-col :span="24">
          <el-form :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">

            <el-form-item prop="email">
              <el-input disabled v-model="form.email" placeholder="Email"></el-input>
            </el-form-item>

            <el-form-item prop="hash">
              <el-input disabled v-model="form.hash" placeholder="Code"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="width-100" @click="submitForm('form')">Confirm</el-button>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <!-- [ Invite User form default ] end -->

</template>

<script>
import axios from 'axios'
  export default {
    props: {
      showForm: {
        type: Boolean
      },
    },
    data() {
      return {

        form: {
          companyId: '',
          email: '',
          hash: '',
        },
        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
          hash: [
            { required: true, message: 'Please input Code', trigger: 'blur' },
            { min: 1, message: 'Length should be 1', trigger: 'blur' }
          ]
        },
      }
    },
    created() {
      if (this.$route.query.companyId) this.form.companyId = this.$route.query.companyId
      if (this.$route.query.email) this.form.email = this.$route.query.email
      if (this.$route.query.hash) this.form.hash = this.$route.query.hash
    },
    methods: {
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios
              .post('/api/v1/companyUsers/confirmUserInvite', {
                companyId: this.form.companyId,
                email: this.form.email,
                hash: this.form.hash
              })
              .then(response => {
                // Handle success.
                // localStorage.setItem('token', response.data.token)
                sessionStorage.setItem('token', response.data.token)
                this.$store.dispatch('loadUser').then(response => {
                  console.log(response)
                  if(response){
                    if(response.companyList){
                      let compare = false
                      response.companyList.forEach(val =>{
                        if(val.id == response.lastCompanyId){
                          compare = true
                          // localStorage.setItem('companyName', val.name)
                          localStorage.setItem('companyId', val.id)
                        }
                      })
                      if(compare){
                        this.$store.dispatch('companyChange', response.lastCompanyId)
                        this.$store.dispatch('getCompanyLayout', response.lastCompanyId).then(re => {
                          console.log('companyUserId', re)
                          let data = {
                            companyId: response.lastCompanyId,
                            companyUserId: re.companyUserId
                          }
                          this.$socket.emit('companyChanged', data)
                        })
                        this.$store.dispatch('getMenuStatistics', response.lastCompanyId).then(resp =>{
                          if(resp.lastProjectId !== null){
                            localStorage.setItem('selectedProjectId', resp.lastProjectId)
                            this.$router.push(`/projects?companyId=${response.lastCompanyId}&projectId=${resp.lastProjectId}`)
                          }else{
                            this.$router.push(`/projects?companyId=${response.lastCompanyId}`)
                          }
                        })
                      }else if (response.lastCompanyId === null) {
                        this.$router.push(`/settings`)
                      }else{
                        this.$store.dispatch('getCompanyLayout', response.companyList[0].id).then(re => {
                          console.log('companyUserId', re)
                          let data = {
                            companyId: response.companyList[0].id,
                            companyUserId: re.companyUserId
                          }
                          this.$socket.emit('companyChanged', data)
                        })
                        this.$store.dispatch('companyChange', response.companyList[0].id)
                        this.$router.push(`/projects?companyId=${response.companyList[0].id}`)
                      }
                    }
                  }
                }, error => {
                  console.error(error)
                })
                // setTimeout(() => {
                //   // console.log('---this.user', this.user);
                //   if(localStorage.getItem('companyId')){
                //     this.$router.push(`/projects?companyId=${localStorage.getItem('companyId')}`);
                //   }else{
                //     this.$router.push(`/projects?companyId=${this.user.companyList[0].id}`);
                //   }
                // }, 1300)
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                // Handle error.
                console.log('An error occurred:', error);
                if (error.response.data.message === "invite_not_exists") {
                  this.notification("Notification", "invite not exists", "info");
                }
                if (error.response.data.message === "user_not_exists_error") {
                  // this.notification("Notification", "User not exists", "info");
                  this.$emit('tab');
                }
                if (error.response.data.message === "invite_already_sended") {
                  this.notification("Notification", "Invite already sended", "info");
                }
                console.log('An error occurred:', error.response.data.message);
                // loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100wh;
	height: 100vh;
  text-align: center;
  padding: 0 20px;

  background: linear-gradient(0deg,#29b996,#3498db);
	background-size: 400% 400%;
	animation: backgroundGradient 10s ease infinite;

  text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-tap-highlight-color: rgba(0,0,0,0);

  @keyframes backgroundGradient {
    0% {
      background-position: 0 0;
    }

    50% {
      background-position: 0 100%;
    }

    100% {
      background-position: 0 0;
    }
  }

  .wrapper {
    box-sizing: border-box;
    max-width: 350px;
    padding: 40px 35px;
    background: #ffffff;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
  .text-align-left {
    text-align: left;
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}
</style>
